import axios from 'axios'
import { handleError } from '@/helpers/HandleError';
import * as general_state from '../store';

const state = {

	// Statistics by faculty for evalvation
	evalvation_statistics_by_faculty: {},
    
};


const getters = {
	// Return statistics by faculty for evalvation
	evalvation_statistics_by_faculty: state => {
		return state.evalvation_statistics_by_faculty;
	},
};


const mutations = {
	// Prepare statistics by faculty
	getEvalvationStatisticsByFaculty: (state, payload) => {
		state.evalvation_statistics_by_faculty = payload;
	},
};


const actions = {
	// Evalvation exports
	exportEvalvationAnalytics: ({commit, dispatch}, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_analytics&action='+payload.export_type+'&year='+general_state.state.year)
			.then(
				res => {
					if(!res.data.success){				
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', {component: 'ModalError', data: error})
					}
					else{
						commit('hideModalWorking');
						dispatch('downloadFile', {url:res.data.export_link, filename:res.data.export_filename});
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},

	// Prepare statistics by faculty
	getEvalvationStatisticsByFaculty: ({commit}, payload) => {
		commit('showModalWorking');
		let year = (payload && payload.year) ? payload.year : general_state.state.year;
		axios.get('?module=evalvation_analytics&action=get_chart_global&year='+year)
			.then(
				res => {
					if(res.data.error){				
						commit('hideModalWorking');
						commit('showModal', {component: 'ModalError', data: res.data.error})
					}
					else{
						commit('getEvalvationStatisticsByFaculty', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));		
	},
};


export default{
	state,
	getters,
	actions,
	mutations	
}